// @note igualar a /store/modules/auth/authTypes
export enum userTypes {
  UNDEFINED= '0',
  LEXON = '1',
  CUSTOMER_PORTAL = '2',
  DMS = '3',
  FACTURE = '4',
  MOBILE = '130',
}

export interface User {
  id: number
  email: string
  name: string
  type: userTypes
  encryptedUserId: string
  userProId: string
  subscription: number[]
  permissions: Permission
  company: Company
  lastAccess: string

  // firstName: string
  // lastName: string
  // idProUser: string
  // idCompany: number
  // companyName: string
  // nif: string
  // dni: string
  // mobilePhone: any
}

export interface Company {
  id: string
  name: string
  database: string
  navisionId: number
  params?: string
  DBHost?: string
}

export interface Permission {}
export interface Credentials {
  email: string
  password: string
}

export interface PreAuthUser {
  id: number
  email: string
  firstName: string
  lastName: string
  companies: Company[]
}

export interface PreAuthData {
  companies?: PreAuthCompany[]
  preAuthToken?: string
  redirectUrl?: string
}

export interface PreAuthCompany {
  id: string
  name: string
}

export interface AuthData {
  accessToken: string
  refreshToken: string
  user: User
}
